import React from 'react';
import { DriverStatus } from '../../types/fleet';
import { statusLabels } from '../../utils/format';
import { cn } from '../../utils/cn';
const styles: Record<DriverStatus, string> = {
  free: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700',
  busy: 'border-amber-500/30 bg-amber-500/10 text-amber-700',
  offline: 'border-red-500/30 bg-red-500/10 text-red-700'
};
const dots: Record<DriverStatus, string> = {
  free: 'bg-emerald-500',
  busy: 'bg-amber-500',
  offline: 'bg-red-500'
};
export function StatusBadge({
  status,
  className
}: {
  status: DriverStatus;
  className?: string;
}) {
  return <span className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium', styles[status], className)} data-id="element-32" data-mp="2tkdkk98edcrz">
      <span className={cn('h-1.5 w-1.5 rounded-full', dots[status])} aria-hidden="true" data-id="element-33" data-mp="3m7rc1rtbtg4p" />
      {statusLabels[status]}
    </span>;
}